
<template>
    <div>
        <Breadtabsheader/>
        <div class="h-content">
            <!-- tab切换 -->
            <el-tabs v-if="tabs.length > 0" v-model="activeName" type="border-card">
                <el-tab-pane
                    v-for="item in tabs"
                    :key="item.name"
                    :label="item.label"
                    :name="item.name">
                    <industryTargetList
                        v-if="activeName === item.name"
                        :contractId="item.contractId"/>
                </el-tab-pane>
            </el-tabs>
            <div v-else class="h-noAuth">暂无可查看的产业数据权限</div>
        </div>
    </div>
</template>
<script>import industryTargetList from './industryTargetList.vue'
export default {
    components: {
        //Breadcrumb,
        industryTargetList
    },
    data() {
        return {
            // 当前选中的Tab
            activeName: "",
            // 四个产业： KS康盛/YX 元析/SD三大/JWX金卫信，对应角色：ks_cymbdr/yx_cymbdr/sd_cymbdr/jwx_cymbdr
            tabList: [
                {label: '康盛', name: 'first', contractId: 'KS', roleCode: 'ks_cymbdr'},
                {label: '元析', name: 'second', contractId: 'YX', roleCode: 'yx_cymbdr'},
                {label: '三大', name: 'third', contractId: 'SD', roleCode: 'sd_cymbdr'},
                {label: '金卫信', name: 'fourth', contractId: 'JWX', roleCode: 'jwx_cymbdr'}
            ]
        };
    },
    computed: {
        // 根据登录人角色过滤可展示的产业Tab，超管展示全部
        tabs() {
            const getters = this.$store.getters;
            const isAdmin = getters.hasRole('swyl_admin');
            return this.tabList.filter(item => isAdmin || getters.hasRole(item.roleCode));
        }
    },
    watch: {
        tabs: {
            handler(list) {
                if (list.length === 0) {
                    this.activeName = "";
                    return;
                }
                // 路由参数指定的Tab需在当前角色可见范围内才生效
                const type = this.$route.query.type;
                if (type && list.some(item => item.name === type)) {
                    this.activeName = type;
                } else if (!list.some(item => item.name === this.activeName)) {
                    this.activeName = list[0].name;
                }
            },
            immediate: true
        }
    }
}
</script>
<style scoped>.h-content {
    background: #fff
}
.h-noAuth {
    padding: 40px 0;
    text-align: center;
    color: #909399;
}
</style>
